<template lang="pug">
  .prestataires.white
    v-dialog.add-client-open(v-model="addUserDialog" width="30%" style="z-index: 10;" persistent)
      v-btn.primary.mb-0(fab small slot="activator")
        v-icon(medium) add
      v-card
        v-card-title.white--text.title.primary.elevation-4
          v-layout.justify-center.align-center
            v-flex.xs10.offset-xs1.text-xs-center CRÉER UN COMPTE
            v-flex.xs1.text-xs-right
              v-icon(large dark @click="addUserDialog = false") close
        v-card-text
          rc-client(context="add" @close="addUserDialog = false; $emit('close')")
    rc-table(
      @mounted="getData"
      @recall="getData"
      @sendEmit="emitEvent"
      ref="clientTable"
      :items="clients"
      :headers="headers"
      :loading="loading"
      :metadata="metadata"
      :clickToVisit="clickToVisit"
      :totalItems="typeof metadata === 'undefined' ? 0 : metadata.count"
      :deleteAction="add && this.$store.state.app.destination.id != 1"
      @tableSearchAction="goToDetails"
      @deleteSelection="deleteSelection"
    )
</template>

<script>
import RcTable from '@/components/RcTable/RcTable.vue';
import RcUserContact from '@/components/RcUserContact/RcUserContact.vue';
import RcClient from '@/components/RcClient/RcClient.vue';
import RcNewClient from '@/components/RcClients/RcNewClient';
import axios from 'axios';
import apiClientService from '@/services/api/ambassador/clientService';

export default {
  components: {
    RcTable,
    RcUserContact,
    RcClient,
    RcNewClient,
  },
  props: {
    add: {
      type: Boolean,
      default: true,
    },
    customActions: {
      type: Array,
      default: () => [],
    },
    clickToVisit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      clients: [],
      metadata: undefined,
      loading: false,
      headers: [
        {
          label: '',
          type: this.$store.state.app.destination.id == 1 ? 'id' : 'selection',
          sortable: false,
          column: 'id',
          padding: 'left',
          width: '70px',
        },
        {
          label: '',
          type: 'tile',
          column: 'image_url',
          partnerType: 'client',
          padding: this.$store.state.app.destination.id == 1 ? 'left' : 'none',
          defaultIcon: 'store',
          width: '80px',
        },
        {
          label: 'Raison sociale',
          // sortable: true,
          column: 'name',
          overflow: 'newline',
          filters: {
            type: 'text',
            operands: ['ilike'],
            entity: 'client',
          },
        },
        {
          label: 'Type',
          // sortable: true,
          column: 'type_ids',
          type: 'types_list',
          filters: {
            type: 'categorized_type_search',
            operands: ['in'],
            values: this.$store.state.clients.searchTypes,
            field: 'id',
            entity: 'res_partner_type',
            label: 'display_name',
          },
        },
        {
          label: 'Téléphone',
          // sortable: true,
          column: 'phone',
          filters: {
            type: 'text',
            operands: ['ilike_remove_space_and_point'],
            entity: 'client',
          },
        },
        {
          label: 'Ville',
          // sortable: true,
          column: 'city',
          filters: {
            type: 'text',
            operands: ['ilike'],
            entity: 'client',
          },
        },
        {
          label: 'Produits',
          // sortable: true,
          column: 'product_ids',
          type: 'products_list',
          filters: {
            type: 'autocomplete',
            operands: ['in'],
            values: [],
            label: 'name',
            key: 'id',
            field: 'pc.id',
          },
          adminOnly: true,
        },
      ],
      addUserDialog: false,
    };
  },
  mounted() {
    if (this.$store.state.app.destination.id == 1) {
      this.getProducts();
    }
  },
  methods: {
    capitalize(string = '') {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    async getProducts() {
      const response = await axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).get('/v2/erp/products/types');
      const products = response.data.data;
      const newHeaders = JSON.parse(JSON.stringify(this.headers))
      const pFilter = newHeaders.find(x => x.column === 'product_ids');
      if (pFilter) {
        pFilter.filters.values = products;
      }
      this.headers = newHeaders;
    },
    async deleteSelection(selected, size) {
      this.loading = true;
      await apiClientService.deleteByIds(selected.map(it => it.id));
      this.$refs.clientTable.selected = [];
      this.getData({});
    },
    emitEvent(data) {
      this.$emit(data.emitName, data.value);
    },
    async getData({ size = 100, start = 0, filters = [] }) {
      this.loading = true;
      const clientResponse = filters.length ? await apiClientService.search(size, start, filters) : await apiClientService.get(size, start);
      this.clients = clientResponse.data;
      this.metadata = clientResponse.metadata;
      this.loading = false;
    },
    goToDetails(data) {
      this.$router.push(`/clients/prestataires/${data.id}`);
    },
  },
};
</script>

<style lang="scss">
  .add-client-open {
    right: 16px;
    top: 88px;
    position: fixed;
    z-index: 2;
  }
</style>
